export default {
  informazioniLegali: 'Informazioni legali',
  companyDetails:
    '© 1994–{year} Pixartprinting S.p.A. a socio unico<br />Soggetta alla direzione e coordinamento di Cimpress plc - P.IVA IT04061550275 - Tutti i diritti riservati.',
  posizioniAperte: 'Posizioni aperte',
  entraNelNostroTeam: 'Entra nel<br>nostro team',
  entraNelTeam: 'Entra nel team',
  scopri: 'Scopri',

  // Links
  infoLegaliLink: 'https://www.pixartprinting.it/informazioni-legali/',
  privacyLink: 'https://www.pixartprinting.it/privacy/',
  cookieLink: 'https://www.pixartprinting.it/cookie-policy/',
  recruitingLink:
    'https://inrecruiting.intervieweb.it/pixartprinting/it/career',
}
